import { getSalarySearchHistoryStats, getSalarySearchHistoryList } from '@/services/jobs/salarySearchHistory.service'

export default {
	namespaced: true,
	state: {
		stats: null,
		statsStatus: 'init',
	},
	getters: {
		getStats: state => state.stats,
		getStatsStatus: state => state.statsStatus,
	},
	mutations: {
		SET_STATS(state, stats) {
			state.stats = stats
		},
		SET_STATS_STATUS(state, status) {
			state.statsStatus = status
		},
	},
	actions: {
		async fetchStats({ commit }) {
			commit('SET_STATS_STATUS', 'loading')
			try {
				const res = await getSalarySearchHistoryStats()
				commit('SET_STATS', res.data.data)
				commit('SET_STATS_STATUS', 'success')
			} catch (e) {
				commit('SET_STATS_STATUS', 'error')
			}
		},
	},
}
